import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "@/components/Helmet";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-100">
      <Helmet>
        <title>Page Not Found | ShadowScan</title>
        <meta
          name="description"
          content="Page not found on the ShadowScan site. Return to the homepage for WordPress security services, threat intelligence, and customer portal access."
        />
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-gray-600">Oops! Page not found</p>
        <a href="/" className="text-blue-500 underline hover:text-blue-700">
          Return to Home
        </a>
      </div>
    </main>
  );
};

export default NotFound;
